/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useEffect,
  useState,
  useContext,
} from "react";
import {
  Col,
  Row,
  Container,
} from "react-bootstrap";

import { NavLink, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { getCDNImage } from "../globals";
import { currencyFormat, i18nValue, getLocale } from "../functions";
import { T } from "react-translator-component";
import Screen from "../components/Screen";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { Clock } from "../components/Icons";
import useBookable from "../hooks/useBookable";
import processHtml from "../components/processHtml";
import PublicPersonPanel from "../components/PublicPersonPanel";
import { usePerson as usePersonContext } from "../context/person";

const PublicBookableList = (props) => {
  const { pathname } = useLocation();

  const [typeItems, setTypeItems] = useState(null);

  const {
    data: hotel,
    currency,
    getUrlPath,
  } = useContext(HotelContext);
  const {
    language,
  } = useContext(UserContext);
  const { data: person } = usePersonContext();  
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [listItemsArray, setListItemsArray] = useState([]);
  const { getBookableList } = useBookable();
  

  useEffect(() => {
    setTypeItems("servicesBooking");
    setTitle(T('services.make-your-reservation'));

    setLoading(true);
    // setListItemsArray([]);
    getBookableList().then((r) => {
      console.log('resp', r);
      setListItemsArray(r ? r : []);
      setLoading(false);
    });

  }, []);

  return (
    <Screen
      section="service"
      title={title}
      description={""}

      // backUrl={!summary ? (requestId ? `./requests/${requestId}` : `./services`) : null}
      backUrl={`./home`}
      showBackButton={person ? false : true}
      hideHeader={person ? true : false}
      headerTranslucid={person ? true : false}
    >
      <PublicPersonPanel
        hotel={hotel}
        person={person}
        getUrlPath={getUrlPath}
      />
      <div className="d-flex justify-content-center align-items-center">

        {loading && <div
          className="loading d-flex justify-content-center align-items-center"
          style={{ height: "100vh", width: "100vw", position: "fixed", top: 0, left: 0 }}
        >
          <div className="spinner-border"></div>
        </div>}

        {!loading && listItemsArray && listItemsArray.length == 0 && (
          <Container className="mt-3">
            <div className="section-empty-data text-center py-4 text-muted">
              {T("public.bookable.list-empty")}
            </div>
          </Container>
        )}

        {!loading && listItemsArray && listItemsArray.length > 0 && typeItems === "servicesBooking" && (
          <Container className="mt-3">

            {listItemsArray.map((val) => {
              if (!val.visible && !val.active) return false;
              if (!val.public) return false;

              let _url = false
              if (typeItems === "servicesBooking") {
                _url = `/${hotel.code}/public/booking/${val.id}`;
              }


              return (
                <NavLink
                  className="mb-2 d-block"
                  to={{
                    pathname: _url,
                  }}
                  state={{ from: pathname }}
                  key={val.id}
                >
                  <Row className="service-booking-item-row item-public">
                    <Col>
                      {val.photo && (
                        <img
                          src={getCDNImage(val.photo)}
                          className="service-full-item-photo photo-size-lg"
                          alt={val.name}
                        />
                      )}
                      {!val.photo && (
                        <img
                          src={"/logo_57.png"}
                          className="service-full-item-photo photo-size-lg no-photo"
                          alt={val.name}
                        />
                      )}
                      <h6 className="service-full-item-name">
                        {i18nValue(val, "name", language)}
                      </h6>
                      <p className="service-full-item-description">
                        {processHtml(i18nValue(val, "description", language))}
                      </p>
                      <div
                        className="general-text-sm mt-2 pt-2"
                        style={{ borderTop: "1px solid #EFEFEF" }}
                      >
                        <Row>
                          <Col className="p-0" style={{ marginTop: 3 }}>
                            {val.duration && (
                              <span>
                                <Clock
                                  className="d-inline-block mr-1 align-bottom"
                                  width={20}
                                  height={20}
                                  color="#999"
                                />
                                {val.durationToShow} minutes
                              </span>
                            )}
                          </Col>
                          <Col className="p-0 text-right">
                            {val.price > 0 && (
                              <span className="general-text">
                                <b>{currencyFormat(val.price, currency)}</b>
                              </span>
                            )}
                            {false && !val.price && (
                              <span className="general-text text-success">
                                <b> {T("general.no-charge")}</b>
                              </span>
                            )}
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </NavLink>
              );
            })}
          </Container>
        )}

      </div>

    </Screen >
  );
}

export default PublicBookableList;